"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareErc1155TemplatesInitialValues = exports.erc1155TemplatesEditFilter = exports.erc1155TemplatesCreateFilter = void 0;
const exchange_1 = require("@framework/exchange");
const types_1 = require("../../../../types");
const erc1155TemplatesCreateFilter = ({ title, description, price, amount, imageUrl, contractId, }) => ({
    title,
    description,
    price: (0, exchange_1.cleanUpAsset)(price),
    amount,
    imageUrl,
    contractId,
});
exports.erc1155TemplatesCreateFilter = erc1155TemplatesCreateFilter;
const erc1155TemplatesEditFilter = ({ title, description, price, amount, imageUrl, templateStatus, }) => ({
    title,
    description,
    price: (0, exchange_1.cleanUpAsset)(price),
    amount,
    imageUrl,
    templateStatus,
});
exports.erc1155TemplatesEditFilter = erc1155TemplatesEditFilter;
const prepareErc1155TemplatesInitialValues = (service, merchantId) => ({ id, title, description, price, amount, templateStatus, contractId, imageUrl }) => {
    return {
        id,
        title,
        description,
        price,
        amount,
        templateStatus,
        contractId,
        imageUrl,
        // this is only filter for contract autocomplete
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareErc1155TemplatesInitialValues = prepareErc1155TemplatesInitialValues;
//# sourceMappingURL=schemas.js.map